import { render, staticRenderFns } from "./TypeMenu.vue?vue&type=template&id=7bdb072a&scoped=true"
import script from "./TypeMenu.vue?vue&type=script&lang=js"
export * from "./TypeMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bdb072a",
  null
  
)

export default component.exports